
import { Box, Dialog, DialogContent } from "@mui/material"
import { yellow } from "@mui/material/colors"
import { BoxFC } from "components/BoxCustom"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import PaperComponent from "components/PaperComponent"
import { DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { numberFormat, dateFormat } from "utils"
import { oilChangeApiNm, oilChangeColNm } from "./constant"

const summaryColumns = [
  { field: "No", headerName: "No.", width: 50, align: "center" },
  { field: "TukCd", headerName: oilChangeColNm.TukId, width: 110 },
  {
    field: "SpNm", headerName: oilChangeColNm.SpId, width: 150,
    valueGetter: ({ value }) => value || "-",
  },
  {
    field: "ChgDte", headerName: oilChangeColNm.ChgDte, width: 110,
    valueFormatter: ({ value }) => dateFormat(value),
  },
  {
    field: "Mileage", headerName: oilChangeColNm.Mileage, width: 110, align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "MileageIntv", headerName: oilChangeColNm.MileageIntv, width: 130, align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "NxtMileage", headerName: oilChangeColNm.NxtMileage, width: 150, align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "CurMileage", headerName: oilChangeColNm.CurMileage, width: 150, align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "NxtDte", headerName: oilChangeColNm.NxtDte, width: 140,
    valueFormatter: ({ value }) => dateFormat(value),
  },
]

const isDue = (row) => {
  if (row.CurMileage == null || row.Mileage == null || !row.MileageIntv) return false
  return +row.CurMileage > (+row.Mileage) + (0.9 * (+row.MileageIntv))
}

const OilChangeSummaryDialog = ({ dialogOpen, setDialogOpen }) => {

  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])

  useEffect(() => {
    if (dialogOpen) {
      ax.post(oilChangeApiNm.getOilChangeSummary, {}).then(value => {
        if (value.data) {
          setDataTable(value.data.map((item, index) => ({ ...item, id: index+1 })))
        }
      })
    }
  }, [dialogOpen, ax])

  const getRowClassName = useCallback((params) => isDue(params.row) ? "due" : "", [])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="lg"
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="สรุปการเปลี่ยนถ่ายน้ำมันล่าสุดของแต่ละคัน"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC pt={2} height={600}>
          <Box height="100%" sx={{ "& .due": { bgcolor: yellow[100], "&:hover": { bgcolor: yellow[200] } } }}>
            <DataGridCellExpand
              hideFooter
              rows={dataTable}
              columns={summaryColumns}
              getRowClassName={getRowClassName}
            />
          </Box>
        </BoxFC>
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(OilChangeSummaryDialog)
